/**
 * Class Menu
 *
 * @author Jeremie Nogues
 * @year 2024
 * @filename menu.js
 * @location /js/my
 */

export default class Menu {
	/**
	 * Constructor
	 */
	constructor(appContext) {
		this.appContext = appContext;
		this.objCommons = this.appContext.get("objCommons");
		this.objRatchet = this.appContext.get("objRatchet");

		//recupère le cookie remember_me_choix
		window.remember_me_choix = this.objCommons.getCookie("remember_me_choix");
		if (window.remember_me_choix === "") {
			window.remember_me_choix = "enseignant";
		}

		//cache les sous menus quand on clique a coté
		document.onmouseup = function (e) {
			if (e.target.id !== "menu") {
				document.querySelectorAll(".sous_menu").forEach(sous_menu => {
					sous_menu.style.display = "none";
				});
			}
		};

		//action sur le bouton vidéos dans la topbar
		this.objCommons.bindEvent("menu_videos", "click", () => {
			window.open(php_to_js_vars.url + "documents/manuel/enseignant#8.1");
		});

		//action sur le bouton manuel dans la topbar
		this.objCommons.bindEvent("menu_manuel", "click", () => {
			window.open(php_to_js_vars.url + "documents/voir");
		});

		//action sur le bouton paramètres dans la topbar
		this.objCommons.bindEvent("menu_tools", "click", () => {
			location.href = php_to_js_vars.url + "utilisateur/parametres";
		});

		//action sur le bouton connect dans la topbar
		this.objCommons.bindEvent("menu_connect", "click", () => {
			this.logout();
		});

		//si le bouton home existe
		this.objCommons.bindEvent("menu_home", "click", () => {

			//si aucune session n'est ouverte
			if (!php_to_js_vars.statut) {

				//renvoie vers la page d'accueil
				location.href = php_to_js_vars.url;
			} else {

				//renvoie vers la page d'accueil du compte
				if (php_to_js_vars.statut === "eleve" || php_to_js_vars.statut === "etudiant") {
					location.href = php_to_js_vars.url + "eleve/accueil";
				} else {
					location.href = php_to_js_vars.url + "utilisateur/accueil";
				}
			}
		});

		//action sur le lien licence dans le footer
		this.objCommons.bindEvent("lien_licence", "click", () => {
			window.open(php_to_js_vars.url + "presentation/licenceUtilisation");
		});

		//action sur le lien mentions dans le footer
		this.objCommons.bindEvent("lien_mentions", "click", () => {
			window.open(php_to_js_vars.url + "presentation/mentionsLegales");
		});

		//action sur le lien confidentialité dans le footer
		this.objCommons.bindEvent("lien_confidentialite", "click", () => {
			window.open(php_to_js_vars.url + "presentation/confidentialite");
		});

		//action sur le lien contact dans le footer
		this.objCommons.bindEvent("lien_contact", "click", () => {

			//importe les modules
			import("./contact").then(({ default: Contact }) => {

				//nouvel objet
				const contact = new Contact(this.appContext);
				contact.dialogContact();
			});
		});
	}
	/**
	 * Déconnexion d'un user
	 */
	logout() {
		$.ajax({
			type: "GET",
			url: php_to_js_vars.url + "logout/logoutUrl",
			cache: false
		}).done((url) => {

			//si c'est un élève
			if (php_to_js_vars.statut === "eleve") {
				this.objRatchet.sendCommand({command: "eleve_logout"});
			}

			//redirige
			location.href = php_to_js_vars.url + "logout/" + url;
		});
	}
	/**
	 * Actions sur le menu de la rubrique classe
	 */
	classes() {

		//renvoie sur la page des classes
		this.objCommons.bindEvent("menu_principal", "click", () => {
			location.href = php_to_js_vars.url + "classes/liste";
		});

		//ouvre le sous menu d'un groupe
		if (document.getElementById("menu_intermediaire")) {

			//si c'est le sous menu module
			if (document.getElementById("sous_menu_module")) {

				//menu module
				this.objCommons.bindEvent("menu_intermediaire", "click", (event) => {
					const rect = event.currentTarget.getBoundingClientRect();
					const left = rect.left + window.scrollX;
					document.getElementById("sous_menu_module").style.left = left + "px";
					this.objCommons.setDisplay("sous_menu_module", "block");
				});

				//boucle pour chaque module
				document.querySelectorAll("#sous_menu_module .sous_menu_item").forEach(module => {

					//action sur le menu
					this.objCommons.bindEvent(module.id, "click", (event) => {
						const _k = event.currentTarget.id.split("_")[3];
						location.href = _k;
					});
				});
			} else {
				//action sur le menu intermédiaire
				this.objCommons.bindEvent("menu_intermediaire", "click", () => {
					location.href = location.href.replace("createEleves", "eleves");
				});
			}
		}
	}
	/**
	 * Actions sur le menu de la rubrique comptes
	 */
	comptes()
	{
		//s'il y a le sous menu
		if (document.getElementById("sous_menu_comptes")) {

			//ouvre le sous menu comptes
			this.objCommons.bindEvent("menu_selected", "click", (event) => {
				const rect = event.currentTarget.getBoundingClientRect();
				const left = rect.left + window.scrollX;
				document.getElementById("sous_menu_comptes").style.left = left + "px";
				this.objCommons.setDisplay("sous_menu_comptes", "block");
			});

			//renvoie à la page de liste des comptes
			this.objCommons.bindEvent("sous_menu_liste", "click", () => {
				location.href = php_to_js_vars.url + "comptes/liste/etablissements/1";
			});

			//renvoie à la page de liste des payeurs
			this.objCommons.bindEvent("sous_menu_resume", "click", () => {
				location.href = php_to_js_vars.url + "comptes/resume";
			});
		} else {
			//renvoie à la page de liste des comptes
			this.objCommons.bindEvent("menu_principal", "click", () => {

				//récupère l'id établissement dans l'url
				const parts = location.pathname.split('/').filter(Boolean);
				const idEtablissement = parts[2];
				location.href = php_to_js_vars.url + "comptes/dossier/" + idEtablissement;
			});
		}
	}
	/**
	 * Actions sur le menu de la rubrique connexion
	 */
	connexion() {

		//renvoie sur la page de connexion
		this.objCommons.bindEvent("menu_principal", "click", () => {
			location.href = php_to_js_vars.url + "connexion/utilisateur";
		});
	}
	/**
	 * Actions sur le menu de la rubrique documents
	 */
	documents() {

		//renvoie sur la page d'accueil des documents
		this.objCommons.bindEvent("menu_principal", "click", () => {
			location.href = php_to_js_vars.url + "documents/voir";
		});
	}
	/**
	 * Actions sur le menu de la rubrique facturation
	 */
	facturation() {

		//ouvre le sous menu facturation
		this.objCommons.bindEvent("menu_selected", "click", (event) => {
			const rect = event.currentTarget.getBoundingClientRect();
			const left = rect.left + window.scrollX;
			document.getElementById("sous_menu_facturation").style.left = left + "px";
			this.objCommons.setDisplay("sous_menu_facturation", "block");
		});

		//renvoie à la page de liste des commandes
		this.objCommons.bindEvent("sous_menu_liste", "click", () => {
			location.href = php_to_js_vars.url + "facturation/liste/1/all";
		});

		//renvoie à la page de liste des payeurs
		this.objCommons.bindEvent("sous_menu_payeurs", "click", () => {
			location.href = php_to_js_vars.url + "facturation/payeurs/1/sans";
		});

		//renvoie à la page de resume
		this.objCommons.bindEvent("sous_menu_resume", "click", () => {
			location.href = php_to_js_vars.url + "facturation/resume/all";
		});

		//renvoie à la page des bordereau
		this.objCommons.bindEvent("sous_menu_bordereau", "click", () => {
			location.href = php_to_js_vars.url + "facturation/bordereaux/nouveaux/1";
		});

		//renvoie à la page de création de devis
		this.objCommons.bindEvent("sous_menu_devis", "click", () => {
			location.href = php_to_js_vars.url + "facturation/devis/1";
		});
	}
	/**
	 * Actions sur le menu de la rubrique forum
	 */
	forum() {

		//action sur le menu principal
		this.objCommons.bindEvent("menu_principal", "click", () => {
			location.href = php_to_js_vars.url + "forum/discussions";
		});

		//action sur le menu intermédiaire
		this.objCommons.bindEvent("menu_intermediaire", "click", () => {

			//récupère l'id_dicussion
			const idDiscussion = document.getElementById("posts_table").dataset.idDiscussion;
			location.href = php_to_js_vars.url + "forum/listeSujets/" + idDiscussion + "/1";
		});
	}
	/**
	 * Actions sur le menu de la rubrique groupes
	 */
	groupes() {

		//récupère les ids dans l'URL
		const parts = location.pathname.split('/').filter(Boolean);
		const idGroupe = parts[2];
		const idModule = parts[3];

		//renvoie à la page de liste des groupes
		this.objCommons.bindEvent("menu_principal", "click", () => {
			location.href = php_to_js_vars.url + "groupes/liste";
		});

		//si c'est la page des precalibrations
		if (js_page_name === "calibrationsPrecalibration") {

			//action sur le menu intermédiaire
			this.objCommons.bindEvent("menu_intermediaire", "click", () => {
				location.href = php_to_js_vars.url + "calibrations/seance/" + idGroupe;
			});
		}

		//ouvre le sous menu d'un groupe
		if (document.getElementById("sous_menu_module")) {

			//menu module
			this.objCommons.bindEvent("menu_intermediaire", "click", (event) => {
				const rect = event.currentTarget.getBoundingClientRect();
				const left = rect.left + window.scrollX;
				document.getElementById("sous_menu_module").style.left = left + "px";
				this.objCommons.setDisplay("sous_menu_module", "block");
			});

			//boucle pour chaque module
			document.querySelectorAll("#sous_menu_module .sous_menu_item").forEach(module => {

				//action sur le menu
				this.objCommons.bindEvent(module.id, "click", (event) => {
					const _k = event.currentTarget.id.split("_")[3];
					location.href = _k;
				});
			});

			//menu seance
			this.objCommons.bindEvent("menu_selected", "click", (event) => {
				const rect = event.currentTarget.getBoundingClientRect();
				const left = rect.left + window.scrollX;
				document.getElementById("sous_menu_seance").style.left = left + "px";
				this.objCommons.setDisplay("sous_menu_seance", "block");
			});

			//sous_menu evaluations
			this.objCommons.bindEvent("sous_menu_evals", "click", () => {
				location.href = php_to_js_vars.url + "evaluations/seance/" + idGroupe + "/" + idModule;
			});

			//sous_menu entrainements
			this.objCommons.bindEvent("sous_menu_entrainements", "click", () => {
				location.href = php_to_js_vars.url + "entrainements/seance/" + idGroupe + "/" + idModule;
			});
			
			//sous_menu entrainements tutore
			this.objCommons.bindEvent("sous_menu_entrainements_tutore", "click", () => {
				location.href = php_to_js_vars.url + "entrainements/tutore/" + idGroupe + "/" + idModule;
			});

			//sous_menu classe inversee
			this.objCommons.bindEvent("sous_menu_classe_inversee", "click", () => {
				location.href = php_to_js_vars.url + "entrainements/inversee/" + idGroupe + "/" + idModule;
			});

			//sous_menu resultats
			this.objCommons.bindEvent("sous_menu_resultats", "click", () => {
				location.href = php_to_js_vars.url + "resultats/voir/" + idGroupe + "/" + idModule;
			});
		}
	}
	/**
	 * Actions sur le menu de la rubrique items
	 */
	items() {

		//récupère l'id_module dans l'URL
		const parts = location.pathname.split('/').filter(Boolean);
		const idModule = parts[2];

		//affiche le sous menu exercices
		this.objCommons.bindEvent("menu_selected", "click", (event) => {
			const rect = event.currentTarget.getBoundingClientRect();
			const left = rect.left + window.scrollX;
			document.getElementById("sous_menu_exercices").style.left = left + "px";
			this.objCommons.setDisplay("sous_menu_exercices", "block");
		});

		//action sur le sous menu resume
		this.objCommons.bindEvent("sous_menu_resume", "click", () => {
			location.href = php_to_js_vars.url + "items/resume/" + idModule;
		});

		//action sur le sous menu liste
		this.objCommons.bindEvent("sous_menu_liste", "click", () => {
			location.href = php_to_js_vars.url + "items/liste/" + idModule + "/1";
		});

		//action sur le sous menu creation
		this.objCommons.bindEvent("sous_menu_creation", "click", () => {
			location.href = php_to_js_vars.url + "items/creation/" + idModule;
		});

		//action sur le sous menu revision
		this.objCommons.bindEvent("sous_menu_revision", "click", () => {
			location.href = php_to_js_vars.url + "items/revision/" + idModule;
		});
	}
	/**
	 * Actions sur le menu de la rubrique forum
	 */
	licence() {

		//action sur le menu principal
		this.objCommons.bindEvent("menu_principal", "click", () => {
			if (php_to_js_vars.statut === "facturation" || php_to_js_vars.statut === "administrateur") {
				history.back();
			} else {
				location.href = php_to_js_vars.url + "licence/gerer/last";
			}
		});
	}
	/**
	 * Actions sur le menu de la rubrique mots
	 */
	mots() {

		//s'il y a le sous menu
		if (document.getElementById("sous_menu_mots")) {

			//ouvre le sous menu mots
			this.objCommons.bindEvent("menu_selected", "click", (event) => {
				const rect = event.currentTarget.getBoundingClientRect();
				const left = rect.left + window.scrollX;
				document.getElementById("sous_menu_mots").style.left = left + "px";
				this.objCommons.setDisplay("sous_menu_mots", "block");
			});

			//renvoie à la page de liste des mots
			this.objCommons.bindEvent("sous_menu_liste_mots", "click", () => {
				location.href = php_to_js_vars.url + "mots/liste/1";
			});

			//renvoie à la page de natures
			this.objCommons.bindEvent("sous_menu_natures", "click", () => {
				location.href = php_to_js_vars.url + "mots/natures/1";
			});
		}
	}
	/**
	 * Actions sur le menu de la rubrique orthophoniste
	 */
	orthophoniste() {

		//action sur le menu principal
		this.objCommons.bindEvent("menu_principal", "click", () => {
			location.href = php_to_js_vars.url + "orthophoniste/patients";
		});

		//action sur le menu intermédiaire
		this.objCommons.bindEvent("menu_intermediaire", "click", () => {

			//récupère l'id du patient dans l'url
			const parts = location.pathname.split('/').filter(Boolean);
			const idPatient = parts[2];
			location.href = php_to_js_vars.url + "patients/dossier/" + idPatient;
		});
	}
}